/* eslint-disable multiline-ternary */
import isEmpty from 'lodash/isEmpty';
import { NextPage } from 'next';
import Head from 'next/head';
import styled from 'styled-components';
// import { useDesktop } from 'src/uti u/devices';
import parse from 'html-react-parser';
import useResponsive from 'src/utils/device';

// ? TODO:  <AdsNative data={Array} isShowAds={boolean} />

/* -------------------------------- KEY_TYPE -------------------------------- */
interface Media {
  isDesktop?: boolean;
  isLaptop?: boolean;
  isTablet?: boolean;
  isMobile?: boolean;
}
interface IAdsNative {
  cat_id?: string;
  group_id?: string;
  name?: string | null;
  header?: string | null;
  body?: string | null;
  mobile_header?: string | null;
  mobile_body?: string | null;
}
interface Props {
  data: IAdsNative | null;
  isShowAds: boolean;
}

const AdsNative: NextPage<Props> = ({ data, isShowAds }) => {
  const _adsArray: IAdsNative | null = !isEmpty(data) ? data : {};
  const MediaQuery: Media = useResponsive();
  if (!isEmpty(_adsArray)) {
    return (
      <>
        <Head>
          {/* -------------------------------- ADS : Native (Mgid) ------------------------------- */}
          {isShowAds && (MediaQuery.isDesktop && data?.header ? parse(data?.header || '') : MediaQuery.isMobile && data?.mobile_header ? parse(data?.mobile_header || '') : '')}
        </Head>
        <AdsWrapper className='ads-native-wrapper'>
          {MediaQuery.isDesktop ? (
            <div id='section-ads' className={`${data?.name}`}>
              {data?.body && <div dangerouslySetInnerHTML={{ __html: data?.body }} />}
            </div>
          ) : (
            <div id='section-ads' className={`${data?.name}`}>
              {data?.mobile_body && <div dangerouslySetInnerHTML={{ __html: data?.mobile_body }} />}
            </div>
          )}
        </AdsWrapper>
      </>
    );
  }
  return null;
};

const AdsWrapper = styled.div`
  #section-ads {
    max-width: 100%;
    width: 80%;
    margin: 30px auto;
    display: flex;
    justify-content: center;
    align-items: center;
    &:first-child {
      @media (max-width: 767px) {
        width: 90%;
      }
    }
  }
  #contents {
    display: flex;
    width: 100%;
    max-width: 95%;
    margin: auto;
  }
`;
export default AdsNative;
